import _objectWithoutProperties from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["input"];
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import KivaProxy from "@/utils/kivaProxy/src";
// import { CityTransformer } from '@/transformers/CityTransformer'
import ClickOutside from "vue-click-outside";
import draggable from "vuedraggable";
import SvgIcon from "@/components/kiva/kvSvgIcon.vue";
import kvTag from "@/components/kiva/kvTag.vue";
import { removeToken } from "@/utils/auth";
export default {
  name: "KvLabelSelect",
  directives: {
    ClickOutside: ClickOutside
  },
  props: {
    value: {},
    model: String,
    app: String,
    id: [Number, Array],
    uniqueId: String,
    width: {
      type: Number,
      default: 200
    },
    viewstyle: {
      default: "standard"
    }
  },
  components: {
    draggable: draggable,
    SvgIcon: SvgIcon,
    kvTag: kvTag
  },
  data: function data() {
    var _ref;
    return _ref = {
      loading: false,
      currentItem: 0,
      unSaveableData: [],
      mutableValue: this.value,
      visible: true,
      tags: [],
      filteredLabels: [],
      selectedTags: [],
      newData: {
        label_name: "",
        label_color: "BCDEFD",
        record_id: null
      },
      editData: {
        label_name: "",
        label_color: "",
        record_id: null
      },
      query: ""
    }, _defineProperty(_ref, "visible", false), _defineProperty(_ref, "newAddVisible", false), _defineProperty(_ref, "app_model", {
      "act/task": 1,
      "inbox/thread": 2,
      "crm/lead": 3,
      "crm/deal": 4,
      "pages/page": 5,
      "dm/document": 6
    }), _defineProperty(_ref, "colors", ["1E44A6", "2887EB", "65B4FB", "BCDEFD", "C0062B", "EE2E45", "E9727E", "FFCDD7", "005D4D", "009B8D", "1BC5BD", "ADE6E3", "FFA800", "F8E814", "FEF697", "FFFEE6", "252F3C", "566980", "91A0B4", "CDD7E2"]), _ref;
  },
  methods: {
    input: function input() {
      this.$emit("input", this.mutableValue);
    },
    handleRemove: function handleRemove(item) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.id) {
                _context.next = 6;
                break;
              }
              _this.loading = true;
              _context.next = 4;
              return new KivaProxy({
                endpoint: "system/label_record"
              }).destroy(item.record_id, {
                erase: 1
              }).then(function (response) {
                _this.getSelectedLabels();
              }).catch(function (err) {
                _this.loading = false;
              });
            case 4:
              _context.next = 8;
              break;
            case 6:
              _this.unSaveableData = _this.unSaveableData.filter(function (k) {
                return k.label.value != item.label.value;
              });
              _this.setSelectedLabels(_this.unSaveableData);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    saveSort: function saveSort() {
      var _this2 = this;
      this.loading = true;
      var data = _toConsumableArray(this.filteredLabels);
      var list = [];
      var i = 1;
      data.forEach(function (k) {
        list.push({
          sort_order: i,
          record_id: k.record_id
        });
        i++;
      });
      var module = new KivaProxy({
        endpoint: "system/label"
      });
      module.update(list).then(function (response) {
        _this2.loading = false;
      });
    },
    handleDelete: function handleDelete(item) {
      var _this3 = this;
      this.$confirm(this.$t("This will be delete. Continue?"), this.$t("Warning"), {
        confirmButtonText: this.$t("OK"),
        cancelButtonText: this.$t("Cancel"),
        type: 'warning'
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(response) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;
                _context2.next = 3;
                return new KivaProxy({
                  endpoint: "system/label"
                }).destroy(item.record_id).then(function (response) {
                  _this3.loading = true;
                  _this3.setNewData();
                  _this3.getLabels();
                  _this3.newAddVisible = false;
                }).catch(function (err) {
                  _this3.loading = false;
                });
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    closeEvent: function closeEvent() {
      this.visible = false;
    },
    nextItem: function nextItem(event) {
      var max = this.filteredLabels.length;
      if (event.keyCode == 38 && this.currentItem > 0) {
        this.currentItem--;
      } else if (event.keyCode == 40 && this.currentItem < max - 1) {
        this.currentItem++;
      }
      var liH = 38;
      this.$refs.kvLabelSelect.scrollTop = liH * this.currentItem;
    },
    choose: function choose(item) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data, newItem;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this4.id) {
                _context3.next = 7;
                break;
              }
              data = {};
              if (typeof _this4.id == 'number') {
                data = {
                  record: _this4.id,
                  app: _this4.app,
                  record_model: _this4.model,
                  label: item.record_id
                };
              } else if (_this4.id && _this4.id[0] && typeof _this4.id[0] == 'number') {
                data = [];
                _this4.id.forEach(function (k) {
                  data.push({
                    record: k,
                    app: _this4.app,
                    record_model: _this4.model,
                    label: item.record_id
                  });
                });
              }
              _context3.next = 5;
              return new KivaProxy({
                endpoint: "system/label_record"
              }).create(data).then(function (response) {
                _this4.getSelectedLabels();
              }).catch(function (err) {
                _this4.loading = false;
              });
            case 5:
              _context3.next = 10;
              break;
            case 7:
              newItem = {
                record_id: null,
                label: {
                  value: item.record_id,
                  label: item.label_name
                },
                record_model: _this4.model,
                app: _this4.app,
                record: _this4.uniqueId,
                relatedData: {
                  label: {
                    record_id: item.record_id,
                    label_name: item.label_name,
                    label_color: item.label_color
                  }
                }
              };
              _this4.unSaveableData.push(newItem);
              _this4.setSelectedLabels(_this4.unSaveableData);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    addNew: function addNew() {
      var _this5 = this;
      this.visible = true;
      setTimeout(function () {
        _this5.$refs.searchField.focus();
      }, 300);
    },
    setNewData: function setNewData() {
      this.newData = {
        label_name: "",
        record_id: null,
        label_color: ""
      };
    },
    saveLabel: function saveLabel(data) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var app_model, method;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              app_model = "".concat(_this6.app, "/").concat(_this6.model);
              data.app_model = _this6.app_model[app_model];
              if (!data.app_model) {
                _context4.next = 9;
                break;
              }
              method = "create";
              if (data.label_id) {
                method = "update";
              }
              _context4.next = 7;
              return new KivaProxy({
                endpoint: "system/label"
              })[method](data).then(function (response) {
                _this6.setNewData();
                _this6.getLabels();
                _this6.newAddVisible = false;
              }).catch(function (err) {
                _this6.loading = false;
              });
            case 7:
              _context4.next = 10;
              break;
            case 9:
              _this6.$notify({
                title: _this6.$t("Failed"),
                message: _this6.$t("This model doesn't have label access."),
                type: "fail"
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    editLabel: function editLabel(data) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return new KivaProxy({
                endpoint: "system/label"
              }).update(data).then(function (response) {
                // this.create =
                _this7.setNewData();
              }).catch(function (err) {
                _this7.loading = false;
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getLabels: function getLabels() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var query, app_model, app_model_id;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              query = _this8.query;
              app_model = "".concat(_this8.app, "/").concat(_this8.model);
              app_model_id = _this8.app_model[app_model];
              _context6.next = 5;
              return new KivaProxy({
                endpoint: "system/label"
              }).setFilters({
                app_model: ["=", app_model_id]
              }).setSort("sort_order").setDir("ASC").all().then(function (response) {
                _this8.loading = false;
                _this8.tags = response.records;

                // this.filteredLabels = [...this.tags]
                _this8.filterLabels();
              }).catch(function (err) {
                _this8.loading = false;
              });
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    filterLabels: function filterLabels() {
      var _this9 = this;
      var val = this.query;
      var labels = this.tags;
      if (val) {
        var s = val.toLowerCase();
        labels = this.tags.filter(function (k) {
          return k.label_name.toLowerCase().includes(s);
        });
      }
      if (labels) {
        labels.forEach(function (k) {
          var f = _this9.selectedTags.find(function (z) {
            return k.record_id == z.label.value;
          });
          if (f) {
            k.selected = true;
          } else {
            k.selected = false;
          }
        });
      }
      this.filteredLabels = labels;
      this.loading = false;
    },
    getSelectedLabels: function getSelectedLabels() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(typeof _this10.id == "number")) {
                _context7.next = 5;
                break;
              }
              _context7.next = 3;
              return new KivaProxy({
                endpoint: "system/label_record"
              }).setFields(['app', 'created_by', 'created_on', 'label', 'record', 'record_id', 'record_model', 'record_owner', 'label/label_color', 'label/record_id', 'label/label_color']).setFilters({
                app: ["=", _this10.app],
                record_model: ["=", _this10.model],
                record: ["=", _this10.id]
              }).all().then(function (response) {
                _this10.setSelectedLabels(response.records);
              }).catch(function (err) {
                _this10.loading = false;
              });
            case 3:
              _context7.next = 8;
              break;
            case 5:
              if (!(_this10.id && _this10.id[0] && typeof _this10.id[0] == 'number')) {
                _context7.next = 8;
                break;
              }
              _context7.next = 8;
              return new KivaProxy({
                endpoint: "system/label_record"
              }).setFields(['app', 'created_by', 'created_on', 'label', 'record', 'record_id', 'record_model', 'record_owner', 'label/label_color', 'label/record_id', 'label/label_color']).setFilters({
                app: ["=", _this10.app],
                record_model: ["=", _this10.model],
                record: ["=", _this10.id[0]]
              }).all().then(function (response) {
                _this10.setSelectedLabels(response.records);
              }).catch(function (err) {
                _this10.loading = false;
              });
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    setSelectedLabels: function setSelectedLabels(records) {
      var _this11 = this;
      this.selectedTags = [];
      records.forEach(function (k) {
        _this11.$emit("isLabelEntered", true);
        var f = _this11.tags.find(function (z) {
          return z.record_id == k.label.value;
        });
        if (f) {
          f.selected = true;
        } else {
          f.selected = false;
        }
        _this11.selectedTags.push(k);
      });
      this.$emit("setUnrecordedLabels", this.selectedTags);
      this.filterLabels();
    }
  },
  computed: {
    attrs: function attrs() {
      return this.$attrs;
    },
    listeners: function listeners() {
      var _this$$listeners = this.$listeners,
        input = _this$$listeners.input,
        listeners = _objectWithoutProperties(_this$$listeners, _excluded);
      return listeners;
    }
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  } // this.getSelectedLabels();
  ,

  watch: {
    value: function value(val) {
      this.mutableValue = val;
    },
    query: function query(val) {
      this.filterLabels();
    },
    id: {
      immediate: true,
      handler: function handler(val) {
        var _this12 = this;
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this12.getLabels();
              case 2:
                _this12.getSelectedLabels();
              case 3:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }))();
      }
    },
    mutableValue: function mutableValue() {
      this.input();
    }
  }
};